import React from 'react';
import './CompactSelect.css';

// The visible selected label sizes the control; the native select keeps OS pickers
// and keyboard semantics without allowing its longest option to dictate width.
export default function CompactSelect({ label, value, options, onChange, className = '' }) {
  return (
    <label className={`pp-compact-select ${className}`}>
      <span className="pp-compact-select-value" aria-hidden="true">
        {options.find(([key]) => key === value)?.[1] ?? value}
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="m6 9 6 6 6-6" />
        </svg>
      </span>
      <select aria-label={label} value={value} onChange={onChange}>
        {options.map(([key, text]) => (
          <option key={key} value={key}>
            {text}
          </option>
        ))}
      </select>
    </label>
  );
}
